/**
 * Check if the device is an iOS device
 * @returns {boolean} True if the device is an iOS device, false otherwise
 */
export default function isIOSDevice(): boolean {
    if (typeof window === 'undefined') return false;

    const userAgent = window.navigator.userAgent.toLowerCase();
  
    return /iphone|ipad|ipod/.test(userAgent);
}